import { connect } from "react-redux";
import { general } from "../../../../../store/action";
import { Accordion } from "react-bootstrap";

type PCGSoundProps = {
  PCGAudioPath?: string;
};

const PCGSound = ({ PCGAudioPath }: PCGSoundProps) => {
  return (
    <>
      <Accordion.Header className="d-flex flex-wrap">
        <div className="flex-fill"></div>
        <span className="font-14 fw-bold me-2 text-black">
          سیگنال‌های صوتی قلب (PCG)
        </span>
      </Accordion.Header>
      <Accordion.Body className="rounded-bottom bg-primary-10">
        <div className="col-12 row">
          <div className="col-12">
            <div className="card-box p-3">
              {/* <div className="mb-2 fw-bold">فایل صوتی PCG</div> */}

              {PCGAudioPath ? (
                <audio controls className="w-100">
                  <source src={PCGAudioPath} type="audio/wav" />
                  مرورگر شما از پخش صدا پشتیبانی نمی‌کند.
                </audio>
              ) : (
                <div className="alert alert-info text-center mb-0">
                  هیچ فایل صوتی PCG برای این بیمار ثبت نشده است.
                </div>
              )}
            </div>
          </div>
        </div>
      </Accordion.Body>
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  handleShowModal: (data: any, body: any) =>
    dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PCGSound);
